import React from 'react';
import {View, StyleSheet, ActivityIndicator} from 'react-native';
import {Text} from 'react-native-paper';
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';
import Animated, {FadeIn} from 'react-native-reanimated';
import {onboardingColors} from '../../theme/onboardingColors';

const SplashScreen = () => {
  return (
    <View style={styles.container}>
      <Animated.View entering={FadeIn.duration(800)} style={styles.logoGroup}>
        <Icon name="content-cut" size={64} color={onboardingColors.primary} />
        <Text variant="headlineLarge" style={styles.title}>
          FabTailor
        </Text>
        <Text variant="bodyMedium" style={styles.tagline}>
          Smart Tailoring Business App
        </Text>
      </Animated.View>
      <ActivityIndicator
        size="small"
        color={onboardingColors.primary}
        style={styles.loader}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: onboardingColors.background,
    justifyContent: 'center',
    alignItems: 'center',
  },
  logoGroup: {
    alignItems: 'center',
  },
  title: {
    fontWeight: 'bold',
    color: onboardingColors.primary,
    marginTop: 12,
  },
  tagline: {
    color: onboardingColors.textSecondary,
    marginTop: 4,
  },
  loader: {
    position: 'absolute',
    bottom: 60,
  },
});

export default SplashScreen;
